/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { OperatorUscaDto } from '../model/operatorUscaDto';
import { OperatorUscaRequest } from '../model/operatorUscaRequest';
import { PageOperatorUscaResponse } from '../model/pageOperatorUscaResponse';
import { BASE_PATH } from '../variables';



@Injectable()
export class OperatorUscaService {

  protected basePath = 'https://fidcaresvil.kiranet.it';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * Create a new Operator Usca
   *
   * @param operatorUscaRequest operatorUscaRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public create2(operatorUscaRequest: OperatorUscaRequest, observe?: 'body', reportProgress?: boolean): Observable<OperatorUscaDto>;
  public create2(operatorUscaRequest: OperatorUscaRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OperatorUscaDto>>;
  public create2(operatorUscaRequest: OperatorUscaRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OperatorUscaDto>>;
  public create2(operatorUscaRequest: OperatorUscaRequest, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (operatorUscaRequest === null || operatorUscaRequest === undefined) {
      throw new Error('Required parameter operatorUscaRequest was null or undefined when calling create2.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      '*/*'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<OperatorUscaDto>(`${this.basePath}/uscas/saveOperatorUsca`,
      operatorUscaRequest,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get the list of the Operator Usca
   *
   * @param districtId districtId
   * @param operatorUscaSurname operatorUscaSurname
   * @param page page
   * @param size size
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findAll1(districtId?: string, operatorUscaSurname?: string, page?: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<PageOperatorUscaResponse>;
  public findAll1(districtId?: string, operatorUscaSurname?: string, page?: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageOperatorUscaResponse>>;
  public findAll1(districtId?: string, operatorUscaSurname?: string, page?: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageOperatorUscaResponse>>;
  public findAll1(districtId?: string, operatorUscaSurname?: string, page?: number, size?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {





    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (districtId !== undefined && districtId !== null) {
      queryParameters = queryParameters.set('districtId', <any>districtId);
    }
    if (operatorUscaSurname !== undefined && operatorUscaSurname !== null) {
      queryParameters = queryParameters.set('operatorUscaSurname', <any>operatorUscaSurname);
    }
    if (page !== undefined && page !== null) {
      queryParameters = queryParameters.set('page', <any>page);
    }
    if (size !== undefined && size !== null) {
      queryParameters = queryParameters.set('size', <any>size);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      '*/*'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<PageOperatorUscaResponse>(`${this.basePath}/uscas/getOperatorUscaList`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
